import {
  GENERATE_PQR_REQUEST,
  GENERATE_PQR_SUCCESS,
  GENERATE_PQR_FAILURE,
  PQR_LOADER_START,
  PQR_LOADER_STOP,
  SET_REPORTS_INFO,
  FETCH_PQR_REPORTS_REQUEST,
  FETCH_PQR_REPORTS_SUCCESS,
  FETCH_PQR_REPORTS_FAILURE,
} from "./types";

const initialState = {
  loading: false,
  data: null,
  reportsInfo: null,
  pqrReportData: null,
  error: null,
};

const data360LivePqrReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERATE_PQR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GENERATE_PQR_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GENERATE_PQR_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    case SET_REPORTS_INFO:
      return {
        ...state,
        loading: false,
        reportsInfo: action.payload.error ? null : action.payload.data,
        error: action.payload.error || null,
      };
    case FETCH_PQR_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PQR_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        pqrReportData: action.payload,
        error: null,
      };
    case FETCH_PQR_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        pqrReportData: null,
        error: action.payload,
      };
    case PQR_LOADER_START:
      return {
        ...state,
        loading: true,
      };
    case PQR_LOADER_STOP:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default data360LivePqrReducer;
